import { config_settings } from '@/config.js';
import Vue from 'vue';

const baseApiUrl = config_settings.RESOURCE_SERVER_URL;

export const getGuiaModuloInfo = () => {
  return Vue.$http.get(baseApiUrl + '/GET/guia_modulo');
};
